import './style.scss';

import React, { Component } from 'react';
import { Redirect, NavLink } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import { ReactSVG } from 'react-svg';
import { GrConfigure } from 'react-icons/gr';

import { Collapse } from 'react-collapse';
import { FaAngleUp, FaAngleDown } from 'react-icons/fa';

import NiceModal from '@ebay/nice-modal-react';
import ModalOnboard from '../../modals/ModalOnboard';

import homeIco from '../../../assets/images/home_02.svg';
import profile from '../../../assets/images/profile.svg';
import jornada from '../../../assets/images/jornada.svg';
import historico from '../../../assets/images/historico.svg';
import externalCourse from '../../../assets/images/externalCourse.svg';
import certificado from '../../../assets/images/certificado.svg';
import gameficacao from '../../../assets/images/game.svg';
import tutorial from '../../../assets/images/tutorial.svg';
import faleConosco from '../../../assets/images/faleConosco.svg';
import adm from '../../../assets/images/adm.svg';
import request from '../../../assets/images/request.svg';
import calendar from '../../../assets/images/calendar.svg';
import CloseIcon from '../../../assets/images/close-icon-menu.svg';


import { logout, getToken, listFilter, getEmail, getSchedules } from '../../../services/api';
import { getSectionByType, getAppDetails } from '../../../services/utils';

import AdminAccess from '../../../components/AdminAccess';
import RedirectAccess from '../../../components/RedirectAccess';
import { MenuInProgress, MenuProducts } from 'pctComponents/molecules';

const stateInit = {
    isDesktop: false,
    user: {},
    contentData: [],
    page: 1,
    totalPages: 0,
    searchTags: '',
    isSearching: false,
    wordRequired: false,
    secondaryExpanded: false,
    needPressEnter: true,
    hideFooter: false,
    currentroom: null,
    showModal: false,
    showRedirect: false,
    sectionTo: null,
    isContactUs: false,
    isTitleProducts: 'Conteúdos',
    showAgenda: false,
};

class MenuPrincipal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...stateInit,
            menuComponentKey: 0,
        };

        this.resize = this.resize.bind(this);
        this.dataBlock = props.dataBlock;
    }

    resetMenu() {
        // forçar remount do MenuProducts and MenuInProgress
        this.setState((prevState) => ({
            ...stateInit,
            menuComponentKey: prevState.menuComponentKey + 1,
        }));
    }


    componentDidMount() {
        this.resize();
        this.setState({
            user: this.getProfileInfo(),
        });
        this.setState({ productsIsButtonCollapseOpen: false });
        this.setState({ inProgressIsButtonCollapseOpen: false });

        window.addEventListener('resize', this.resize);

        getEmail('CONTACT_US')
            .then((response) => {
                this.setState({ isContactUs: !!response.data.active });
            })
            .catch((error) => {
                // console.log(error);
            });

        const getAppDetailsBucket = getAppDetails().bucket;
        const bucketStatus =
            getAppDetailsBucket === 'learninghub.peoplecraft.com.br' || getAppDetailsBucket === 'educacao.totvs.com'
                ? 'Produtos e Trilhas'
                : 'Conteúdos';

        this.setState({ isTitleProducts: bucketStatus });

        getSchedules()
            .then((res) => {
                const count = res.data.scheduleResult.totalRecords;

                this.setState({
                    showAgenda: (Number.isFinite(count) ? count : 0) > 0,
                });
            })
            .catch(() => {
                this.setState({ showAgenda: false });
            });
    }

    getProfileInfo() {
        let token = {};
        try {
            token = jwtDecode(getToken());
        } catch {
            console.log('error on token get');
        }
        return token;
    }

    focusInput(shouldFocus) {
        if (this.nameInput) {
            if (shouldFocus) {
                this.nameInput.focus();
                this.setState({ wordRequired: true, isSearching: true });
            } else {
                this.setState({
                    wordRequired: false,
                    isSearching: false,
                    searchTags: '',
                    contentData: [],
                });
            }
        }
    }

    resize() {
        this.setState({ isDesktop: window.innerWidth > 900 });
    }

    logout() {
        logout();
        this.setState({ redirect: true });
    }

    findContentState(word) {
        if (word.length === 0) {
            this.setState({ isLoading: false, searchTags: word, isSearching: false });
            return;
        }
        if (word.length === 1 || word.length === 2) {
            this.setState({
                isLoading: false,
                searchTags: word,
                isSearching: true,
                wordRequired: true,
                contentData: [],
            });
            return;
        }
        this.setState({ searchTags: word, wordRequired: false, page: 1 }, () => {
            this.findContent();
        });
    }

    findContent() {
        if (this.state.searchTags.length === 0) {
            return;
        }
        if (this.state.searchTags.length === 1 || this.state.searchTags.length === 2) {
            return;
        }

        this.setState({
            isLoading: true,
            isSearching: true,
            wordRequired: false,
            page: 1,
            needPressEnter: false,
        });
        listFilter(0, { page: 1, searchTags: this.state.searchTags })
            .then((res) => {
                if (!res || res.data.success === false) {
                    this.setState({ isLoading: false, contentData: [], totalPages: 0 });
                    return;
                }
                if (res.data.success === false) {
                    this.setState({ isLoading: false });
                    return;
                }
                this.setState({
                    isLoading: false,
                    contentData: res.data.content,
                    totalPages: Math.ceil(res.data.totalRecord / res.data.content.length), // divide by number of total items by page
                });
            })
            .catch((err) => {
                this.setState({ isLoading: false });
                console.log('error ', err);
            });
    }

    hideFooter(value) {
        this.setState({ hideFooter: value });
    }

    searchByPage(page) {
        const data = {
            page: page,
            searchTags: this.state.searchTags,
        };

        this.setState({ isLoading: true, page: page });

        listFilter(0, data)
            .then((res) => {
                if (!res || res.data.success === false) {
                    this.setState({ isLoading: false, data: [], totalPages: 0 });
                    return;
                }
                this.setState({
                    isLoading: false,
                    contentData: res.data.content,
                    totalPages: Math.ceil(res.data.totalRecord / res.data.content.length),
                });
            })
            .catch((err) => {
                console.log('err ', err);
                this.setState({ isLoading: false });
            });
    }

    openChat() {
        this.hideFooter(true);
        this.setState({ secondaryExpanded: true });
    }

    closeChat() {
        this.setState({ secondaryExpanded: false });
        this.hideFooter(false);
    }

    leaveChat() {
        this.setState({ currentroom: null });
        this.hideFooter(false);
    }

    handleChangeRoom(r) {
        this.setState({
            currentroom: r,
            hideFooter: true,
        });
    }

    _getMenuData() {
        return getSectionByType(1);
    }


    render() {

        
        if (this.state.redirect) {
            return <Redirect to="/login" />;
        }
      
        const menuData = localStorage.getItem('menu-data') ? JSON.parse(localStorage.getItem('menu-data')) : {};
        const appDetails = JSON.parse(localStorage.getItem('appDetails'));

        const domainURL = menuData?.loginInfo?.adminDomain || appDetails.adminDomain;

        const getAdmLink = () => {
            let linkAdm = '';

            if (!menuData) {
                linkAdm = `https://${domainURL}`;
            } else {
                linkAdm = `https://${domainURL}/?token=${menuData.token}#/login`;
            }

            return linkAdm;
        };

        const userIsAdmin = () => {
            return menuData?.loginInfo?.admin > 0;
        };

        const userCanAccessSupport = () => {
            return Boolean(menuData?.loginInfo?.canAccessSupport);
        };

        
        const handleCollapseProducts = (e) => {
            this.setState({
                productsIsButtonCollapseOpen: this.state.productsIsButtonCollapseOpen ? false : true,
            });
        };

        const handleCollapseInProgerss = (e) => {
            this.setState({
                inProgressIsButtonCollapseOpen: this.state.inProgressIsButtonCollapseOpen ? false : true,
            });
        };

        const inAccessSupport = Boolean(menuData?.loginInfo?.accessSupport?.isActive);

        return (
            <>
                <div
                    className={'menu-expand ' + (this.props.expanded ? 'menu-expand-open' : '')}
                    style={{
                        overflowY: this.state.isSearching ? 'auto' : 'hidden',
                    }}
                >
                    <div className="menu-hit" onClick={() => this.props.expand()}></div>

                    <div className="menu-secondary-container">
                        <div style={{ display: 'flex', flex: 1 }}>
                            <div className="menu-secondary-left">
                                {/* CLOSE BTN */}
                                <ReactSVG
                                    onClick={() => this.props.expand()}
                                    className="menu-secondary-left-item menu-secondary-left-item-closed"
                                    beforeInjection={(svg) => {
                                        svg.setAttribute(
                                            'style',
                                            `width: 20px; height: 20px; margin-bottom: 5px; fill: #fff`,
                                        );
                                    }}
                                    src={CloseIcon}
                                    alt="fechar menu"
                                />
                                {/* HOME */}
                                <NavLink
                                    to=""
                                    exact
                                    onClick={() => this.props.expand()}
                                    className="menu-secondary-left-item"
                                    // activeClassName="left-item-selected"
                                >
                                    <ReactSVG src={homeIco} alt="img" className="navLinkImg" />
                                    <div className="navLinkTxt">Home</div>
                                </NavLink>
                                {/* MINHA JORNADA */}
                                <NavLink
                                    to="/myjourney"
                                    onClick={() => this.props.expand()}
                                    className="menu-secondary-left-item"
                                    //activeClassName="left-item-selected"
                                >
                                    <ReactSVG src={jornada} alt="img" className="navLinkImg" />
                                    <div className="navLinkTxt">Minha jornada</div>
                                </NavLink>
                                {/* Solicitações de matrícula */}
                                {this.props.hasEnrollmentRequests && (
                                    <NavLink
                                        to="/myjourney/requestEnrollmentStatus"
                                        onClick={() => this.props.expand()}
                                        className="menu-secondary-left-item"
                                        //activeClassName="left-item-selected"
                                    >
                                        <ReactSVG src={request} alt="img" className="navLinkImg" />
                                        <div className="navLinkTxt">Solicitações de matrícula</div>
                                    </NavLink>
                                )}
                                {/* Meu Historico */}
                                <NavLink
                                    to="/myjourney/historic"
                                    onClick={() => this.props.expand()}
                                    className="menu-secondary-left-item"
                                    //activeClassName="left-item-selected"
                                >
                                    <ReactSVG src={historico} alt="img" className="navLinkImg" />
                                    <div className="navLinkTxt">Meu histórico</div>
                                </NavLink>
                                {/* Meu Certificados */}
                                <NavLink
                                    to="/myjourney/certificates"
                                    onClick={() => this.props.expand()}
                                    className="menu-secondary-left-item"
                                    //activeClassName="left-item-selected"
                                >
                                    <ReactSVG src={certificado} alt="img" className="navLinkImg" />
                                    <div className="navLinkTxt">Meus certificados</div>
                                </NavLink>
                                {this.props.isInCampaign && (
                                    <NavLink
                                        to="/myjourney/gamification"
                                        onClick={() => this.props.expand()}
                                        className="menu-secondary-left-item"
                                        //activeClassName="left-item-selected"
                                    >
                                        <ReactSVG src={gameficacao} alt="img" className="navLinkImg" />
                                        <div className="navLinkTxt">Campanhas e Gamificação</div>
                                    </NavLink>
                                )}
                                {/* Cursos Externos */}
                                {this.props.externalcourses && (
                                    <NavLink
                                        to="/myjourney/externalCourse"
                                        onClick={() => this.props.expand()}
                                        className="menu-secondary-left-item"
                                        //activeClassName="left-item-selected"
                                    >
                                        <ReactSVG src={externalCourse} alt="img" className="navLinkImg" />
                                        <div className="navLinkTxt">Cursos externos</div>
                                    </NavLink>
                                )}
                                {this.state.showAgenda && (
                                    <NavLink
                                        to="/calendar"
                                        onClick={() => this.props.expand()}
                                        className="menu-secondary-left-item"
                                        // activeClassName="left-item-selected"
                                    >
                                        <ReactSVG src={calendar} alt="img" className="navLinkImg"/>
                                        <div className="navLinkTxt">Agenda</div>
                                    </NavLink>
                                )}
                                <NavLink
                                    to="/editPerfil"
                                    onClick={() => this.props.expand()}
                                    className="menu-secondary-left-item"
                                    // activeClassName="left-item-selected"
                                >
                                    <ReactSVG src={profile} alt="img" className="navLinkImg" />
                                    <div className="navLinkTxt">Meu perfil</div>
                                </NavLink>
                                {/* TUTORIAL */}
                                {menuData?.loginInfo?.onBoardScreen && (
                                    <div
                                        onClick={() => {
                                            NiceModal.show(ModalOnboard, {
                                                obj: {
                                                    // closedModal:(e) => {
                                                    //
                                                    // }
                                                },
                                            });
                                            this.props.expand();
                                        }}
                                        className="menu-secondary-left-item"
                                        //activeClassName="left-item-selected"
                                    >
                                        <ReactSVG src={tutorial} alt="img" className="navLinkImg" />
                                        <div className="navLinkTxt">Tutorial</div>
                                    </div>
                                )}
                                {/* FALE CONOSCO */}
                                {this.state.isContactUs && (
                                    <NavLink
                                        to="/contactus"
                                        onClick={() => this.props.expand()}
                                        className="menu-secondary-left-item"
                                        //activeClassName="left-item-selected"
                                    >
                                        <ReactSVG src={faleConosco} alt="img" className="navLinkImg" />
                                        <div className="navLinkTxt">Fale conosco</div>
                                    </NavLink>
                                )}
                                {/*  ADM */}
                                {userIsAdmin() && (
                                    <>
                                        {!inAccessSupport && (
                                            <a
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={getAdmLink()}
                                                onClick={() => this.props.expand()}
                                                className="menu-secondary-left-item"
                                            >
                                                <ReactSVG src={adm} alt="img" className="navLinkImg" />
                                                <div className="navLinkTxt">Administração</div>
                                            </a>
                                        )}

                                        {/* Acesso Suporte */}
                                        {userCanAccessSupport() && !inAccessSupport && (
                                            <button
                                                onClick={() => {
                                                    this.props.expand();
                                                    this.props.showModalAccessSupport();
                                                }}
                                                className="menu-secondary-left-item support-button"
                                            >
                                                <div className="navLinkImg">
                                                    <div>
                                                        <GrConfigure alt="img" className="injected-svg menu-icon" />
                                                    </div>
                                                </div>
                                                <div className="navLinkTxt">Acesso Suporte</div>
                                            </button>
                                        )}
                                    </>
                                )}
                                {inAccessSupport && (
                                    <button
                                        onClick={() => {
                                            this.props.expand();
                                            this.props.closeSupportAccess();
                                        }}
                                        className="menu-secondary-left-item support-button"
                                    >
                                        <div className="navLinkImg">
                                            <div>
                                                <GrConfigure alt="img" className="injected-svg menu-icon" />
                                            </div>
                                        </div>
                                        <div className="navLinkTxt">Sair do acesso suporte</div>
                                    </button>
                                )}
                            </div>
                            <div className="menu-secondary-right">
                                <div className="menu-item">
                                    <button
                                        className={`${
                                            this.state.productsIsButtonCollapseOpen
                                                ? 'menuItemIsOpen'
                                                : 'menuItemIsClose'
                                        } menu-text-btn`}
                                        onClick={(e) => {
                                            handleCollapseProducts(e);
                                        }}
                                    >
                                        <span className="menu-text"> {this.state.isTitleProducts} </span>
                                        {this.state.productsIsButtonCollapseOpen ? <FaAngleUp /> : <FaAngleDown />}
                                    </button>

                                    <Collapse isOpened={this.state.productsIsButtonCollapseOpen}>
                                        <MenuProducts key={this.state.menuComponentKey} closeRoot={this.props.expand} />
                                    </Collapse>
                                </div>

                                <div className="menu-item">
                                    {/* <span className="menu-text"> Continue de onde parou </span> */}
                                    <button
                                        className={`${
                                            this.state.inProgressIsButtonCollapseOpen
                                                ? 'menuItemIsOpen'
                                                : 'menuItemIsClose'
                                        } menu-text-btn`}
                                        onClick={(e) => {
                                            handleCollapseInProgerss(e);
                                        }}
                                    >
                                        <span className="menu-text"> Continue de onde parou </span>
                                        {this.state.inProgressIsButtonCollapseOpen ? <FaAngleUp /> : <FaAngleDown />}
                                    </button>

                                    <Collapse isOpened={this.state.inProgressIsButtonCollapseOpen}>
                                        <MenuInProgress
                                            key={this.state.menuComponentKey}
                                            closeRoot={this.props.expand}
                                        />
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.showModal && (
                        <AdminAccess
                            denyAction={() => this.setState({ ...this.state, showModal: false })}
                            acceptAction={() => this.setState({ ...this.state, showModal: false })}
                        />
                    )}
                    {this.state.showRedirect && (
                        <RedirectAccess
                            idSection={this.state.sectionTo}
                            denyAction={() => this.setState({ ...this.state, showRedirect: false })}
                            acceptAction={() => this.setState({ ...this.state, showRedirect: false })}
                        />
                    )}
                </div>
            </>
        );
    }
}


export default MenuPrincipal;
